// extracted by mini-css-extract-plugin
export var cancelIcon = "xxLHF";
export var checkMarkIcon = "bd5yX";
export var dialog = "RwAs9";
export var dialogContent = "yiAJ_";
export var dialogSubtext = "yCGOH";
export var dialogTitle = "r502m";
export var spinner = "ZZk3_";
export var spinnerCircle = "VtgxZ";